import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const crewUnavailability =(request) =>{  
    let ENDPOINT = ''; 
    let year   = request.data.year;   
    let month   = request.data.month;  
    let crewId = request.data.crewId;
    if(crewId && crewId!==0){
        ENDPOINT = URL_BASE_API+'affiliate/crew-unavailability-list/?year='+year+'&month='+month+'&crew_profile_id='+crewId;
    }else{
        ENDPOINT = URL_BASE_API+'affiliate/crew-unavailability-list/?year='+year+'&month='+month;
    }

    let departments = 0; 
    if(request.data.filtersData && request.data.filtersData.departments && request.data.filtersData.departments.length) {
        departments = JSON.stringify(request.data.filtersData.departments); 
    }
    if(departments) ENDPOINT += '&departments='+departments;  

    return service.get(ENDPOINT);
}

export const crewUnavailabilityPerDate =(request) =>{ 
    let ENDPOINT = ''; 
    let date   = request.data.date;
    let crewId = request.data.crewId;
    if(crewId && crewId!==0){
        ENDPOINT = URL_BASE_API+'affiliate/crew-unavailability-list-datewise/?date='+date+'&crew_profile_id='+crewId;
    }else{
        ENDPOINT = URL_BASE_API+'affiliate/crew-unavailability-list-datewise/?date='+date; 
    }

    let departments = 0; 
    if(request.data.filtersData && request.data.filtersData.departments && request.data.filtersData.departments.length) {
        departments = JSON.stringify(request.data.filtersData.departments); 
    }
    if(departments) ENDPOINT += '&departments='+departments;  
    
    return service.get(ENDPOINT);
}

export const unavailableCrewList =(request) =>{  
    let crewName = request.data.crewName;
    const ENDPOINT = URL_BASE_API+'affiliate/affiliates-crew-list/?crew_name='+crewName;
    return service.get(ENDPOINT);
}
export const saveUnavailability =(request) =>{  
    let data = request.data;
    const ENDPOINT = URL_BASE_API+'user/save-unavalability/';
    return service.post(ENDPOINT,data);
}
export const updateUnavailability =(request) =>{  
    let data = request.data;
    let unavailabilityId = data['id']
    const ENDPOINT = URL_BASE_API+'user/get-update-unavalability/'+unavailabilityId;
    return service.put(ENDPOINT,data);
}
export const deleteUnavailability =(request) =>{  
    let unavailabilityId = request.data.unavailabilityId;
    const ENDPOINT = URL_BASE_API+'user/get-update-unavalability/'+unavailabilityId;
    return service.delete(ENDPOINT);
}
export const getUnavailability =(request) =>{  
    let unavailabilityId = request.data.unavailabilityId;
    const ENDPOINT = URL_BASE_API+'user/get-update-unavalability/'+unavailabilityId;
    return service.get(ENDPOINT);
}